import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Student } from "../types/students";
import { BASE_URL, envConfig } from "../config";
// Define a service using a base URL and expected endpoints
export const studentsApi = createApi({
  reducerPath: "studentsApi",
  baseQuery: fetchBaseQuery({
    credentials: "include",
    baseUrl: BASE_URL + "students",
    prepareHeaders: (headers) => {
        headers.set("api-key", `${envConfig.API_KEY}`);

      return headers;
    },
  }),
  tagTypes: ["Students"],
  endpoints: (builder) => ({
    getStudents: builder.query<Student[], string>({
      query: () => `/`,
      providesTags: ["Students"],
    }),
    updateStudent: builder.mutation<Student, Student>({
      query: ({ _id, ...patch }) => ({
        url: `/${_id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: ["Students"],
    }),
    deleteStudent: builder.mutation<{ success: boolean; _id: string }, string>({
      query: (_id) => ({
        url: `/${_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Students"],
    }),
    createStudent: builder.mutation<Student, Student>({
      query: ({ _id, ...student }) => ({
        url: `/`,
        method: "POST",
        body: student,
      }),
      invalidatesTags: ["Students"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetStudentsQuery,
  useUpdateStudentMutation,
  useCreateStudentMutation,
  useDeleteStudentMutation,
} = studentsApi;
